import React from "react";
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import green from '@mui/material/colors/green';
import amber from '@mui/material/colors/amber';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import WarningIcon from '@mui/icons-material/Warning';
import { withStyles } from '@mui/material/styles';

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};


function SnackbarWrapper(props: any) {
    const { classes, className, message, onClose, variant, ...other } = props;

    return (
        <SnackbarContent
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" >
                    {message}
                </span>
            }
            action={[
                <IconButton
                    key="close" 
                    aria-label="Close"
                    color="inherit"
                    // className={classes.close}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>,
            ]}
            {...other}
        />
    );
}

export default SnackbarWrapper;
